import React, { useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../images/services-usa/iphone-new/banner_iphone.webp";

function Banner(props) {
  // Function to handle the scroll action
  const scrollToCaseStudies = () => {
    const caseBtnElement = document.getElementById("case_btn");
    if (caseBtnElement) {
      // Using `scrollIntoView` to scroll to the target element
      caseBtnElement.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <div
      className="service_usa web_dev_service iphone_banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={7} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <h1 className="web_head_banner" style={{ marginBottom: "10px" }}>
                IOS App Development Company in USA
              </h1>
              <span style={{ color: "#000" }}>
                Create High-Performance, Interactive iOS Apps
              </span>
              <p style={{ color: "#898989" }}>
                Build dynamic, consistent applications that win over more Apple
                users. TekRevol’s iOS app development services help businesses
                create and deploy built-for-experience solutions for bigger,
                better digital visibility.
              </p>

              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Consult Your App Idea
              </Link>
              <button
                className="border_btn web_case_btn"
                aria-label="TekRevol Contact"
                onClick={scrollToCaseStudies}
              >
                Case Studies
              </button>
            </div>
          </Col>
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="mt-auto">
            <div className="iphone_banner_img">
              <StaticImage
                src="../../images/services-usa/iphone-new/iphone_banner_mob.webp"
                alt="tekrevol_web"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={631}
                height={791}
              />
            </div>

            {/* <img src={GIF} alt="TekRevol" /> */}
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
